export default {
  'Group.addProduct': 'Add Product',
  'Group.report': 'Report',
  'Group.sentimentDynamics': 'Sentiment dynamics',
  'Group.filterTopics': 'All topics',
}
